import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=ebf3ba6c&scoped=true&"
import script from "./SubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=ebf3ba6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf3ba6c",
  null
  
)

export default component.exports